


































































































































































































































































































































































































































































import { Prop, Watch, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import SimpleTile from '@/components/common/SimpleTile.vue'
import { Accountext, Package } from 'dapp-client'

const numeral = require('numeral')

@Component({
  components: {
    SimpleTile
  }
})
export default class Statistics extends Vue {
  // data
  private numeral = numeral

  // computed
  get dspRanking() {
    return vxm.dappservices.dspRanking
  }

  get accountTable() {
    return vxm.dappservices.accountTable
  }

  get packageTable() {
    return vxm.dappservices.packageTable
  }

  get statextTable() {
    return vxm.dappservices.statextTable
  }

  get dapphdlStakedTable() {
    return vxm.user.dapphdlStakingTable
  }

  get totalStaked() {
    return parseFloat(this.statextTable.staked)
  }

  get activeSupply() {
    return (
      parseFloat(this.statextTable.supply) -
      parseFloat(this.statextTable.supply_instant) -
      parseFloat(this.statextTable.supply_regular)
    )
  }

  get dapphdlStaked() {
    let staked = 0
    for (const a of this.dapphdlStakedTable) {
      staked += parseFloat(a.balance)
    }
    return staked
  }

  get dappStaked() {
    return this.totalStaked - this.dapphdlStaked
  }

  get stakedByService() {
    let ipfs = 0
    let cron = 0
    let oracle = 0
    let stake = 0
    for (const a of this.usersByService.ipfs) {
      ipfs += parseFloat(a.balance)
    }
    for (const a of this.usersByService.cron) {
      cron += parseFloat(a.balance)
    }
    for (const a of this.usersByService.oracle) {
      oracle += parseFloat(a.balance)
    }
    for (const a of this.usersByService.stake) {
      stake += parseFloat(a.balance)
    }
    return { ipfs: ipfs, cron: cron, oracle: oracle, stake: stake }
  }

  get usersByStatus() {
    let active: Accountext[] = []
    let lowStake: Accountext[] = []
    let zeroStake: Accountext[] = []
    active = this.accountTable.filter((a: Accountext) => a.status === 'active')
    lowStake = this.accountTable.filter(
      (a: Accountext) => a.status === 'low stake'
    )
    lowStake.concat(
      this.accountTable.filter((a: Accountext) => a.status === 'depleted')
    )
    zeroStake = this.accountTable.filter(
      (a: Accountext) => a.status === 'zero stake'
    )
    return { active: active, lowStake: lowStake, zeroStake: zeroStake }
  }

  get usersByService() {
    let ipfs: Accountext[] = []
    let cron: Accountext[] = []
    let oracle: Accountext[] = []
    let stake: Accountext[] = []
    ipfs = this.accountTable.filter(
      (a: Accountext) => a.service === 'ipfsservice1'
    )
    cron = this.accountTable.filter(
      (a: Accountext) => a.service === 'cronservices'
    )
    oracle = this.accountTable.filter(
      (a: Accountext) => a.service === 'oracleservic'
    )
    stake = this.accountTable.filter(
      (a: Accountext) => a.service === 'stakeservice'
    )
    return { ipfs: ipfs, cron: cron, oracle: oracle, stake: stake }
  }

  get activeUsersByService() {
    let ipfs: Accountext[] = []
    let cron: Accountext[] = []
    let oracle: Accountext[] = []
    let stake: Accountext[] = []
    ipfs = this.usersByStatus.active.filter(
      (a: Accountext) => a.service === 'ipfsservice1'
    )
    cron = this.usersByStatus.active.filter(
      (a: Accountext) => a.service === 'cronservices'
    )
    oracle = this.usersByStatus.active.filter(
      (a: Accountext) => a.service === 'oracleservic'
    )
    stake = this.usersByStatus.active.filter(
      (a: Accountext) => a.service === 'stakeservice'
    )
    return { ipfs: ipfs, cron: cron, oracle: oracle, stake: stake }
  }

  get lowStakeUsersByService() {
    let ipfs: Accountext[] = []
    let cron: Accountext[] = []
    let oracle: Accountext[] = []
    let stake: Accountext[] = []
    ipfs = this.usersByStatus.lowStake.filter(
      (a: Accountext) => a.service === 'ipfsservice1'
    )
    cron = this.usersByStatus.lowStake.filter(
      (a: Accountext) => a.service === 'cronservices'
    )
    oracle = this.usersByStatus.lowStake.filter(
      (a: Accountext) => a.service === 'oracleservic'
    )
    stake = this.usersByStatus.lowStake.filter(
      (a: Accountext) => a.service === 'stakeservice'
    )
    return { ipfs: ipfs, cron: cron, oracle: oracle, stake: stake }
  }

  get zeroStakeUsersByService() {
    let ipfs: Accountext[] = []
    let cron: Accountext[] = []
    let oracle: Accountext[] = []
    let stake: Accountext[] = []
    ipfs = this.usersByStatus.zeroStake.filter(
      (a: Accountext) => a.service === 'ipfsservice1'
    )
    cron = this.usersByStatus.zeroStake.filter(
      (a: Accountext) => a.service === 'cronservices'
    )
    oracle = this.usersByStatus.zeroStake.filter(
      (a: Accountext) => a.service === 'oracleservic'
    )
    stake = this.usersByStatus.zeroStake.filter(
      (a: Accountext) => a.service === 'stakeservice'
    )
    return { ipfs: ipfs, cron: cron, oracle: oracle, stake: stake }
  }

  get dspByService() {
    let ipfs = 0
    let cron = 0
    let oracle = 0
    let stake = 0
    for (const dsp of this.dspRanking) {
      if (dsp.services.includes('ipfsservice1')) ipfs += 1
      if (dsp.services.includes('cronservices')) cron += 1
      if (dsp.services.includes('stakeservice')) stake += 1
      if (dsp.services.includes('oracleservic')) oracle += 1
    }
    return { ipfs: ipfs, cron: cron, oracle: oracle, stake: stake }
  }

  get pkgByStatus() {
    let available: Package[] = []
    let deprecated: Package[] = []
    for (const pkg of this.packageTable) {
      if (this.isDeprecated(pkg)) deprecated.push(pkg)
      else available.push(pkg)
    }
    return { available: available, deprecated: deprecated }
  }

  get pkgByService() {
    let ipfs: Package[] = []
    let cron: Package[] = []
    let oracle: Package[] = []
    let stake: Package[] = []
    ipfs = this.packageTable.filter(
      (pkg: Package) => pkg.service === 'ipfsservice1'
    )
    cron = this.packageTable.filter(
      (pkg: Package) => pkg.service === 'cronservices'
    )
    oracle = this.packageTable.filter(
      (pkg: Package) => pkg.service === 'oracleservic'
    )
    stake = this.packageTable.filter(
      (pkg: Package) => pkg.service === 'stakeservice'
    )
    return { ipfs: ipfs, cron: cron, oracle: oracle, stake: stake }
  }

  get availablePkgByService() {
    let ipfs: Package[] = []
    let cron: Package[] = []
    let oracle: Package[] = []
    let stake: Package[] = []
    ipfs = this.pkgByStatus.available.filter(
      (pkg: Package) => pkg.service === 'ipfsservice1'
    )
    cron = this.pkgByStatus.available.filter(
      (pkg: Package) => pkg.service === 'cronservices'
    )
    oracle = this.pkgByStatus.available.filter(
      (pkg: Package) => pkg.service === 'oracleservic'
    )
    stake = this.pkgByStatus.available.filter(
      (pkg: Package) => pkg.service === 'stakeservice'
    )
    return { ipfs: ipfs, cron: cron, oracle: oracle, stake: stake }
  }

  get deprecatedPkgByService() {
    let ipfs: Package[] = []
    let cron: Package[] = []
    let oracle: Package[] = []
    let stake: Package[] = []
    ipfs = this.pkgByStatus.deprecated.filter(
      (pkg: Package) => pkg.service === 'ipfsservice1'
    )
    cron = this.pkgByStatus.deprecated.filter(
      (pkg: Package) => pkg.service === 'cronservices'
    )
    oracle = this.pkgByStatus.deprecated.filter(
      (pkg: Package) => pkg.service === 'oracleservic'
    )
    stake = this.pkgByStatus.deprecated.filter(
      (pkg: Package) => pkg.service === 'stakeservice'
    )
    return { ipfs: ipfs, cron: cron, oracle: oracle, stake: stake }
  }

  // methods
  isDeprecated(pkg: Package) {
    return !(
      pkg.api_endpoint !== '' &&
      pkg.api_endpoint !== null &&
      pkg.api_endpoint !== 'null' &&
      pkg.api_endpoint !== undefined
    )
  }

  // Lifecycle hooks
  created() {
    vxm.user.getDapphdlStakingTable()
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
